import { useMutation } from 'react-query';
import { acknowledgeAnnouncement } from '../../services/announcement.service';

export const useAcknowledgeAnnouncement = () => useMutation((announcementId) => acknowledgeAnnouncement(announcementId));
